import { SessionStatus } from '@zeus/index'

/** Libellé de chaque statut de session, partagé par la liste, ses filtres et le formulaire. */
export const SESSION_STATUS_KEYS: Record<SessionStatus, string> = {
  [SessionStatus.ACTIVE]: 'status.active',
  [SessionStatus.ARCHIVED]: 'status.archived',
}
